
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'V2CurrentPlanCard',
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
})
